<template>
  <payment-status
    @hasError="processErrorInvoice"
    @paymentInfo="setPaymentInfo"
  >
    <div slot-scope="{ paymentInfo, isLoading }">
      <loading-screen v-if="isLoading" />
      <div
        v-if="isInvoicePayment || isCreatingRecurringPayment || isChangingCard"
        class="payment-info"
      >
        <exclamation-triangle
          v-if="isCreatingRecurringPayment"
          scale="3"
          color="red"
          class="w-full"
        />
        <check-circle
          v-else
          scale="3"
          color="red"
          class="w-full"
        />
        <h2
          class="payment-info__title"
        >
          {{ isCreatingRecurringPayment
            ? $t('recurrence.creatingRecurrence.title')
            : isChangingCard
              ? $t('recurrence.updateCard.title')
              : '¡Gracias por tu pago!' }}
        </h2>
        <tabbed
          v-if="isCreatingRecurringPayment"
          :title="$t('recurrence.creatingRecurrence.tabtitle')"
        >
          <p class="text-sm">
            {{ $t('recurrence.creatingRecurrence.text') }}
          </p>
        </tabbed>
        <p
          v-else
          class="bold"
        >
          {{ isChangingCard ? $t('recurrence.updateCard.text') : $t('text.satisfactionMsg') }}
        </p>
        <payment-detail
          v-if="isInvoicePayment"
          :payment-info="paymentInfo"
          :money="country.money"
        />
        <p
          v-if="isInvoicePayment && !isCreatingRecurringPayment && !isChangingCard"
          class="bold"
        >
          Recibirás un correo electrónico de confirmación del pago de tu factura Claro.
        </p>
        <button
          class="button"
          @click="onClick"
        >
          {{ isInvoicePayment || isCreatingRecurringPayment
            ? $t('text.exit') : $t('text.finalize') }}
        </button>
      </div>
    </div>
  </payment-status>
</template>
<script>
import { mapGetters } from 'vuex';
import { CheckCircle, ExclamationTriangle } from '@/components/icons';
import jwt from 'jwt-decode';
import storage from '@lagersoft/key-storage';
import Tabbed from '@/components/Tabbed';
import PaymentStatus from '@/views/common/RenderlessComponents/PaymentStatus';
import PaymentDetail from '@/views/common/Components/PaymentDetail';

export default {
  name: 'PaymentInfoMpc',
  components: {
    PaymentStatus,
    Tabbed,
    CheckCircle,
    ExclamationTriangle,
    PaymentDetail
  },
  data() {
    return {
      notificationNumber: '',
      error: '',
      payment: {},
      messagePosted: false
    };
  },
  computed: {
    ...mapGetters(['country', 'isChatbot']),
    isCreatingRecurringPayment() {
      return !this.isChangingCard && this.payment && !!this.payment.successInfo
      && this.payment.successInfo.isCreatingRecurringPayment;
    },
    isInvoicePayment() {
      return this.payment && !!this.payment.successInfo
      && this.payment.successInfo.invoicesInfo.length > 0;
    },
    isChangingCard() {
      return this.payment && !!this.payment.successInfo
      && this.payment.successInfo.isUpdatingRecurringPaymentCard;
    }
  },
  beforeDestroy() {
    if (this.isChatbot) {
      this.postMessage();
    }
  },
  methods: {
    goBack() {
      if (!this.isChatbot) {
        this.$router.push({ name: 'SetNumber' });
      } else this.postMessage();
    },
    processErrorInvoice(paymentStatus) {
      if (paymentStatus === 'RejectedUsaCardWhilstRecurringWithoutInvoices'.toUpperCase()) {
        this.$router.push({ name: 'PaymentRejectedUsa' });
      } else this.$router.push({ name: 'Error', query: { error: paymentStatus } });
    },
    setPaymentInfo(payment) {
      this.payment = payment;
    },
    postMessage() {
      if (!this.messagePosted) {
        const token = jwt(storage.get('tokenIvr'));
        const success = this.payment && this.payment.invoiceOrderStatus === 'Successful';
        const operationType = 'Pago de servicios';
        const date = success ? new Date(this.payment.successInfo.operationDate) : new Date();
        const number = (success && this.payment.successInfo.invoicesInfo.serviceId) || token.number;
        const operationId = `Chatbot${number}${date
          .toISOString()
          .replace(/\D/g, '')
          .substring(0, 14)}`;
        const paymentError = this.payment
          && this.payment.invoiceOrderStatus
          && this.payment.invoiceOrderStatus
          ? this.$t(`chatbot.error.${this.payment.invoiceOrderStatus.toUpperCase()}`)
          : 'Error Procesando Transaccion';
        const ErrorDescription = success ? '' : paymentError;
        const PayLoad = success ? 'Tu pago se ha realizado con éxito' : '';
        const code = success ? 0 : 9;

        window.parent.postMessage(
          {
            success,
            operationType,
            operationId,
            code,
            date,
            ErrorDescription,
            PayLoad
          },
          '*'
        );

        this.messagePosted = true;
      }
    },
    acceptNotificationMsisdn() {
      this.error = '';
      if (
        this.notificationNumber.length !== 0
        && this.notificationNumber.length !== 8
      ) {
        this.error = 'El número ingresado debe ser de 8 dígitos.';
        return;
      }
      this.isLoading = true;
      const notificationNumberWithLada = this.notificationNumber ? `${this.country.lada}${this.notificationNumber}` : '';
      global.api
        .updateRecurringPaymentNotificationMsisdn(
          this.$route.params.folio,
          notificationNumberWithLada,
          'MPCInvoice'
        )
        .then(() => {
          this.goBack();
        })
        .catch((err) => {
          if (err.response.status === 400) {
            this.error = 'El número ingresado no es Claro.';
          } else {
            this.error = 'Ha ocurrido un error, favor de intentar más tarde';
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onClick() {
      if (this.isCreatingRecurringPayment) {
        this.acceptNotificationMsisdn();
      } else { this.goBack(); }
    }
  }
};
</script>

<style lang="scss" scoped>
.payment-info {
  display: grid;
  gap: 1rem;
  text-align: center;
  margin-top: 2rem;
  width: 100%;
}

.payment-info__title {
  font-size: 1.75rem;
  font-weight: bold;
  width: 100%;
}

.chatbot {
  .payment-info {
    gap: 0.25rem;
    box-sizing: border-box;
    margin-top: 1rem;
    padding-inline: 0.5rem;
    font-size: .875rem;
  }
  .payment-info__title {
    font-size: 1.5rem;
    margin-bottom: 0.25rem;
  }
}

</style>
